(function () {
    'use strict';

    realmCommerceApp.controller("CustomerRegistrationController", CustomerRegistrationController);

    /*@ngInject*/
    function CustomerRegistrationController() {
        var vm = this;

        vm.registrationModel = {}
        vm.detailsFields = [
            {
                key: 'firstNames',
                type: 'input',
                name: 'first_names',
                templateOptions: {
                    labelOptions: {
                        label: 'First Name'
                    },
                    placeholder: 'First Name',
                    required: true
                }
            },
            {
                key: 'lastName',
                name: 'last_name',
                type: 'input',
                templateOptions: {
                    labelOptions: {
                        label: 'Last Name'
                    },
                    placeholder: 'Last Name',
                    required: true
                }
            },
            {
                key: 'phoneNumber',
                name: 'phone_home',
                type: 'input',
                templateOptions: {
                    labelOptions: {
                        label: 'Contact Number'
                    },
                    type: 'tel',
                    placeholder: 'Contact Number',
                    required: true
                },
                controller: /*@ngInject*/($scope) => {
                    $scope.$watch('model.phoneNumber', (newValue) => {
                        if ($scope.fc) {
                            $scope.fc.$setValidity('telephoneNumber', false);
                            if (/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(newValue)) {
                                $scope.fc.$setValidity('telephoneNumber', true);
                            }
                        }
                    });
                },
                validation: {
                    messages: {
                        telephoneNumber: ($viewValue) => $viewValue + ' is not a valid phone number'
                    }
                }
            },
            {
                key: 'emailAddress',
                name: 'email_address',
                type: 'input',
                templateOptions: {
                    labelOptions: {
                        label: 'Email'
                    },
                    placeholder: 'Email',
                    type: 'email',
                    required: true
                }
            }
        ];
        vm.registrationPasswordFields = [
            {
                key: 'password',
                type: 'input',
                name: 'password',
                templateOptions: {
                    labelOptions: {
                        label: 'New Password'
                    },
                    type: 'password',
                    placeholder: 'New Password',
                    required: true
                }
            },
            {
                key: 'confirm_password',
                name: 'confirm_password',
                type: 'input',
                templateOptions: {
                    type: 'password',
                    labelOptions: {
                        label: 'Confirm Password'
                    },
                    placeholder: 'Confirm Password',
                    required: true
                },
                controller: /*@ngInject*/($scope) => {
                    $scope.$watch('model.confirm_new_password', (newValue) => {
                        if (newValue !== $scope.model.password) {
                            $scope.fc.$setValidity('passwordMatch', false);
                        }
                    });
                },
                validation: {
                    messages: {
                        passwordMatch: () => 'Passwords have to match!'
                    }
                }
            }
        ];
        vm.registrationFields = angular.copy(vm.detailsFields).concat(vm.registrationPasswordFields);
    }
})();




// WEBPACK FOOTER //
// ./static/js/app/customer/customer.registration.js